import remarkGFM from "remark-gfm";
import Markdown from "react-markdown";
import { cn } from "@aichat/ui/lib/utils";
import { UserConversationRoleEnum } from "@aichat/types/index";
import { MessageContainerProps } from "./chat__v2/_components/message-container";
import { getHSLAString } from "@aichat/aichat-lib";
import { darkHSLA, lightHSLA } from "@aichat/constants/widget";
type MarkdownRendererProps = {
  text: string;
  className?: string;
  widgetConfig: MessageContainerProps["widgetConfig"];
  role: UserConversationRoleEnum;
  type?: "portal-chat" | "widget-chat";
};

function MarkdownRenderer({
  text,
  widgetConfig,
  role,
  type,
  className,
}: MarkdownRendererProps) {
  const { textColor } = widgetConfig;
  const mainTextColorHSLA = getHSLAString({
    ...(textColor === "dark" ? darkHSLA : lightHSLA),
    a: 1,
  });

  const applyUrlColor =
    type === "widget-chat" && role === UserConversationRoleEnum.CUSTOMER;
  return (
    <div className={cn("markdown prose [&>p]:break-words", className)}>
      <Markdown
        remarkPlugins={[remarkGFM]}
        components={{
          a: ({ ...props }) => (
            <a
              {...props}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                ...(applyUrlColor && {
                  color: mainTextColorHSLA,
                }),
              }}
            />
          ),
        }}
      >
        {text}
      </Markdown>
    </div>
  );
}

export default MarkdownRenderer;
